import api from './axios';

export const getDashboardReport  = ()       => api.get('/reports/dashboard');
export const getAttendanceReport = (params) => api.get('/reports/attendance', { params });
export const getFinanceReport    = (params) => api.get('/reports/finance', { params });
export const getTeachersReport   = (params) => api.get('/reports/teachers', { params });
export const getDebtReport       = (params) => api.get('/reports/debt', { params });
export const getManualDebtsReport = (params) => api.get('/reports/manual-debts', { params });
export const getCoursesReport    = ()       => api.get('/reports/courses');
export const getSchoolsReport    = ()       => api.get('/reports/schools');
export const getMonthlyTrend     = ()       => api.get('/reports/monthly-trend');
export const getRoutinesReport   = (params) => api.get('/reports/routines', { params });
export const getHiddenProgressReport = (params) => api.get('/reports/hidden-progress', { params });

// --- Excel dışa aktarımı -------------------------------------------------
//
// AYRI ROTA DEĞİL: aynı ucun `?export=xlsx` parametresi (bkz. backend
// ReportController::excelCikti). Şube kapısı, filtre ve sıralama tek yerde
// kalıyor; ikinci bir uç yazılsaydı zamanla saparlar ve "ekranda 40 satır
// var, Excel'de 52" denirdi.
//
// `responseType: 'blob'` ŞART — yoksa axios ikili içeriği metne çevirip
// dosyayı bozar. Sayfalama parametresi gönderilse bile sunucu yok sayıyor:
// dosyanın amacı listeyi personele bölüştürmek, 20 satır o işi görmez.
const excelIstek = (yol, params) =>
  api.get(yol, { params: { ...params, export: 'xlsx' }, responseType: 'blob' });

export const exportDebtReport         = (params) => excelIstek('/reports/debt', params);
export const exportManualDebtsReport  = (params) => excelIstek('/reports/manual-debts', params);
export const exportReenrollmentReport = (params) => excelIstek('/reports/reenrollment', params);
